(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[34,104],{

/***/ "1OyB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _classCallCheck; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "CN8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HaE+");
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("1OyB");
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vuIU");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("JX7q");
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Ji7U");
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("md7G");
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("foSv");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("20a2");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _requests_sectors__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("UzFu");
/* harmony import */ var _requests_stores__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("JC4P");
/* harmony import */ var _material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("wb2y");
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("/MKj");
/* harmony import */ var _store_modules_popup_manager_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("pOqu");









var __jsx = react__WEBPACK_IMPORTED_MODULE_8___default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */








var mapStateToProps = function mapStateToProps(state) {
  return {
    coords: state.root.coords
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setType: function setType(type) {
      return dispatch(Object(_store_modules_popup_manager_actions__WEBPACK_IMPORTED_MODULE_14__[/* setType */ "i"])(type));
    }
  };
};

var Footer = /*#__PURE__*/function (_Component) {
  Object(_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(Footer, _Component);

  var _super = _createSuper(Footer);

  function Footer(props) {
    var _this;

    Object(_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(this, Footer);

    _this = _super.call(this, props);
    _this.state = {
      categories: [],
      windowLayout: false
    };
    _this.updateSize = _this.updateSize.bind(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_this));
    _this.onClickCategoria = _this.onClickCategoria.bind(Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(_this));
    return _this;
  }

  Object(_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(Footer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        windowLayout: window.innerWidth <= 750 ? 0 : 750
      });
      window.addEventListener("resize", this.updateSize);
      this.loadCategories();
    }
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(prevProps) {
        var coords;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                coords = this.props.coords;

                if (prevProps.coords !== coords) {
                  this.loadCategories();
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.updateSize);
    }
  }, {
    key: "onClickCategoria",
    value: function onClickCategoria(category) {
      var _this$props = this.props,
          _this$props$coords = _this$props.coords,
          latitude = _this$props$coords.latitude,
          longitude = _this$props$coords.longitude,
          router = _this$props.router,
          setType = _this$props.setType;

      if (latitude && longitude) {
        router.push("/[content]", "/".concat(encodeURI(category.name)));
      } else {
        setType("select-area");
      }
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var windowLayout = this.state.windowLayout;

      if (window.innerWidth > 750 && windowLayout !== 750) {
        this.setState({
          windowLayout: 750
        });
      } else if (window.innerWidth <= 750 && windowLayout !== 0) {
        this.setState({
          windowLayout: 0
        });
      }
    }
  }, {
    key: "loadCategories",
    value: function () {
      var _loadCategories = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2() {
        var _this$props2, coords, setType, _yield$fetchSectors, categories, response2;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, coords = _this$props2.coords, setType = _this$props2.setType;
                _context2.next = 3;
                return Object(_requests_sectors__WEBPACK_IMPORTED_MODULE_10__[/* fetchSectors */ "a"])(coords);

              case 3:
                _yield$fetchSectors = _context2.sent;
                categories = _yield$fetchSectors.categories;
                this.setState({
                  categories: categories.slice(0, 5)
                });

                if (!((coords === null || coords === void 0 ? void 0 : coords.latitude) && (coords === null || coords === void 0 ? void 0 : coords.longitude))) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 9;
                return Object(_requests_stores__WEBPACK_IMPORTED_MODULE_11__[/* fetchNearbyStores */ "a"])({
                  coords: coords,
                  page: 0,
                  pageSize: 4
                });

              case 9:
                response2 = _context2.sent;
                return _context2.abrupt("return", (response2.status !== 200 || !response2.companies.length) && setType("location-off"));

              case 11:
                return _context2.abrupt("return", 0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadCategories() {
        return _loadCategories.apply(this, arguments);
      }

      return loadCategories;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          categories = _this$state.categories,
          windowLayout = _this$state.windowLayout;
      return __jsx("div", {
        id: "footer"
      }, __jsx("h3", null, "Ajude o pequeno. Compre de quem est\xE1 do seu lado."), __jsx(_material_ui_core_Divider__WEBPACK_IMPORTED_MODULE_12__[/* default */ "a"], null), __jsx("div", {
        className: "footer-container"
      }, __jsx("div", {
        className: "col-8"
      }, __jsx("div", {
        className: "logo-footer"
      }, __jsx("img", {
        src: windowLayout === 750 ? "/images/logomarca-completa-dolado.png" : "/images/iconedolado.png",
        alt: "Imagem Indispon\xEDvel"
      })), __jsx("div", {
        className: "list-holder"
      }, __jsx("p", {
        className: "footer-title"
      }, "Principais Categorias"), __jsx("ul", null, categories.map(function (category, idx) {
        return __jsx("li", {
          key: idx,
          onClick: function onClick() {
            return _this2.onClickCategoria(category);
          }
        }, category.name);
      })))), __jsx("div", {
        className: "col-2"
      }, __jsx("div", {
        className: "list-holder"
      }, __jsx("p", {
        className: "footer-title"
      }, "Entre em Contato"), __jsx("ul", null, __jsx("li", null, "das 09 \xE0s 18h"), __jsx("li", null, "seg \xE0 sex"), __jsx("li", null, "contato@compredolado.com.br")))), __jsx("div", {
        className: "col-2"
      }, __jsx("div", {
        className: "list-holder"
      }, __jsx("p", {
        className: "footer-title"
      })))), __jsx("div", {
        className: "copyright"
      }, __jsx("p", null, "\xA9 2021 - Darez Atividades de Internet ltda. Todos os direitos reservados")));
    }
  }]);

  return Footer;
}(react__WEBPACK_IMPORTED_MODULE_8__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Object(react_redux__WEBPACK_IMPORTED_MODULE_13__[/* connect */ "b"])(mapStateToProps, mapDispatchToProps)(Object(next_router__WEBPACK_IMPORTED_MODULE_9__["withRouter"])(Footer)));

/***/ }),

/***/ "Ji7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ _inherits; });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ "UzFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchSectors; });
/* unused harmony export fetchCountProductsPerSubsectorPerSector */
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("HaE+");
/* harmony import */ var _config_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("o75L");




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


function fetchSectors() {
  return _fetchSectors.apply(this, arguments);
}

function _fetchSectors() {
  _fetchSectors = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee() {
    var _ref,
        latitude,
        longitude,
        urlBack,
        response,
        data,
        categories,
        _args = arguments;

    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, latitude = _ref.latitude, longitude = _ref.longitude;
            _context.prev = 1;
            urlBack = "/v1/categories";
            if (latitude && longitude) urlBack += "?lat=".concat(latitude, "&lng=").concat(longitude);
            _context.next = 6;
            return _config_api__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get(urlBack);

          case 6:
            response = _context.sent;
            data = response.data;
            categories = [];

            if (response.status === 200) {
              categories = data.categories.map(function (ctg) {
                var temp = _objectSpread({}, ctg);

                if (temp.icon) temp.icon = data.bucket_url + temp.icon;
                if (temp.banner) temp.banner = data.bucket_url + temp.banner;
                return temp;
              });
            }

            return _context.abrupt("return", {
              status: response.status,
              categories: categories
            });

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](1);
            return _context.abrupt("return", {
              status: 500,
              categories: []
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 13]]);
  }));
  return _fetchSectors.apply(this, arguments);
}

function fetchCountProductsPerSubsectorPerSector(_x) {
  return _fetchCountProductsPerSubsectorPerSector.apply(this, arguments);
}

function _fetchCountProductsPerSubsectorPerSector() {
  _fetchCountProductsPerSubsectorPerSector = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(storeId) {
    var response, categories;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return _config_api__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].get("/v1/products/subcategory/companies/".concat(storeId));

          case 3:
            response = _context2.sent;
            categories = response.data;
            Object.keys(categories).forEach( // eslint-disable-next-line no-return-assign
            function (key) {
              return categories[key] = {
                subcategories: Object.entries(categories[key]).map(function (item) {
                  return item[0];
                }),
                total: Object.entries(categories[key]).map(function (item) {
                  return item[1];
                }).reduce(function (total, item) {
                  return total + item;
                })
              };
            });
            return _context2.abrupt("return", categories);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", []);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));
  return _fetchCountProductsPerSubsectorPerSector.apply(this, arguments);
}

/***/ }),

/***/ "foSv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _getPrototypeOf; });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "md7G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _possibleConstructorReturn; });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("U8pU");
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("JX7q");


function _possibleConstructorReturn(self, call) {
  if (call && (Object(_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(self);
}

/***/ })

}]);